import { render } from "./TesteeForm.vue?vue&type=template&id=1add0c5a&scoped=true"
import script from "./TesteeForm.vue?vue&type=script&lang=js"
export * from "./TesteeForm.vue?vue&type=script&lang=js"

import "./TesteeForm.vue?vue&type=style&index=0&id=1add0c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1add0c5a"

export default script